import axios from '~/config/axios';

interface IHeader {
  name: string;
  value: string;
}

interface IList extends Array<IHeader> {}

export function setAxiosHeader(list: IList): void {
  list.forEach(header => {
    const { name, value } = header;
    axios.defaults.headers.common[name] = value;
  });
}
